import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'

export interface WorkSpacesMapProps {
  workAreaId: string
  workSpaces: WorkSpaceWithBookingNode[]
  actions: MapActions
  mapMode?: MapMode
}

export interface MapActions {
  onPinClick?: (data: { workSpaceId: number }) => void
  onMapClick?: (data: { x: number; y: number }) => void
  onPinHover?: (data: { workSpaceId: number | null }) => void
}

export type MapMode = 'DEFAULT' | 'PLACE_PIN'

export const MAP_MODE: Record<MapMode, MapMode> = { DEFAULT: 'DEFAULT', PLACE_PIN: 'PLACE_PIN' }
